export const isOsrSummarySupportedCrop = (cropName?: string): boolean => {
  const normalized = (cropName ?? '').toLowerCase();
  return normalized === 'grain corn' || normalized === 'silage corn' || normalized === 'sunflower';
};
